import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {percent} from '@packages/systems/core/utils/WebflowCssSubset';
import {UsysUtilityPageConstraint, extraAttrs} from './utils';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const UserFormButton = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const buttonClasses = classes.push('w-button');
    return <input {...generateAttributes(attributes, buttonClasses)} />;
  }
);

const config = createIntegratedAtom({
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  constraints: {
    page: [UsysUtilityPageConstraint],
  },
  showEmpty: false,
  displayName: 'Submit Button',
  render: UserFormButton,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord(
        {
          value: withSystem({label: 'Text', isFullWidth: true}, TText),
          'data-wait': withSystem(
            {label: 'Waiting Text', isFullWidth: true},
            TText
          ),
        },
        extraAttrs
      )
    ),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          width: percent(100),
          textAlign: 'center',
        },
      },
    },
  },
});

export default config;
